import React from 'react';
import {Line} from "react-chartjs-2";
import {
    COLORS,
    filterEmptyLabels,
    formatTemperature,
    formatTooltipLabel,
    formatTooltipTitle,
    formatWaterLevel
} from "../utils/ChartFormatUtils";
import * as ChartSettings from "./ChartSettings";
import {externalTooltipHandler} from "../utils/ChartStylingUtils";
import useWindowWidth from "../hooks/useWindowWidth";

function DualAxisChart({data, ...props}) {
    ChartSettings.registerComponents()

    const windowWidth = useWindowWidth()

    const options = {
        responsive: true,
        aspectRatio: windowWidth < 768 ? 1.2 : 2.3,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                callbacks: {
                    title: formatTooltipTitle,
                    label: formatTooltipLabel,
                },
                enabled: false,
                external: externalTooltipHandler
            }
        },
        interaction: {
            intersect: false,
            mode: 'index',
        },
        scales: {
            //labels
            x: {
                ticks: {
                    color: COLORS.chartColorMain,
                    callback: filterEmptyLabels
                },
                grid: {
                    color: COLORS.chartColorLight
                }
            },

            waterLevel: {
                type: 'linear',
                position: 'left',
                ticks: {
                    color: COLORS.chartColorMain,
                    callback: value => formatWaterLevel(value),
                    padding: 6
                },
                grid: {
                    drawOnChartArea: false
                }
            },

            temperature: {
                type: 'linear',
                position: 'right',
                ticks: {
                    color: COLORS.chartColorMain,
                    callback: value => formatTemperature(value)
                },
                grid: {
                    drawOnChartArea: false
                },
                min: -4,
                max: 35
            }
        }
    }

    return <Line
        data={data}
        options={options}
        {...props}
    />
}

export default DualAxisChart;